import $ from 'jquery';

Drupal.behaviors.contactUs = {
  attach() {
    $('body')
      .once('contactUs')
      .each((index, element) => this.contactUs(element));
  },

  contactUs() {
    const body = $('body');
    const qcModal = $('.quick-contact-modal');
    const qcReqModal = $('.quick-request-modal');
    const qcButton = $('.quick-contact-toggle-button');
    const qcReqButton = $('.quick-request-toggle-button');
    const qcModalClose = $('.quick-contact-modal__icon-close');
    const qcReqModalClose = $('.quick-request-modal__icon-close');
    const qcContactButton = $('.quick-contact-modal__header-contact');
    const qcRequestButton = $('.quick-contact-modal__header-request');
    const qcContactForm = $('.quick-contact-modal__form-contact');
    const qcRequestForm = $('.quick-contact-modal__form-request');
    const tel = $('.contact__tel');

    // Show contact form.
    function showQcContact() {
      qcContactButton.addClass('quick-contact-modal__header-contact--active');
      qcContactForm.addClass('quick-contact-modal__form-contact--active');
      qcRequestButton.removeClass('quick-contact-modal__header-request--active');
      qcRequestForm.removeClass('quick-contact-modal__form-request--active');
    }

    // Show request form
    function showQcRequest() {
      qcRequestButton.addClass('quick-contact-modal__header-request--active');
      qcRequestForm.addClass('quick-contact-modal__form-request--active');
      qcContactButton.removeClass('quick-contact-modal__header-contact--active');
      qcContactForm.removeClass('quick-contact-modal__form-contact--active');
    }

    // Show phone No.
    function showTelNumber(e) {
      e.stopPropagation();
      $('.contact__tel').toggleClass('is_visible');
    }

    // Toogle modal.
    function toggleQcModal() {
      showQcContact();
      if (qcModal.hasClass('quick-contact-modal--open')) {
        qcModal.removeClass('quick-contact-modal--open');
        body.removeClass('modal-open');
      } else {
        qcModal.addClass('quick-contact-modal--open');
        body.addClass('modal-open');
      }
    }

    function toggleQcReqModal() {
      showQcRequest();
      if (qcReqModal.hasClass('quick-request-modal--open')) {
        qcReqModal.removeClass('quick-request-modal--open');
        body.removeClass('modal-open');
      } else {
        qcReqModal.addClass('quick-request-modal--open');
        body.addClass('modal-open');
      }
    }

    // Toggle modal.
    qcButton.on('click', toggleQcModal);
    qcModalClose.on('click', toggleQcModal);

    qcReqButton.on('click', toggleQcReqModal);
    qcReqModalClose.on('click', toggleQcReqModal);

    // Toggle between forms.
    qcContactButton.on('click', showQcContact);
    qcRequestButton.on('click', showQcRequest);

    // Show tel No.
    tel.on('click', showTelNumber);
  },
};

